export const ACTIONS = {
  QUERY_REQUEST: 'query:request',
  UI_OUTPUT: 'outputui',
  IFRAME_OUTPUT: 'iframeoutput',
  POSTFORMDATA_REQUEST: 'postformdata:request',
  SETSTATE: 'setstate',
  DONE: 'done',
  RUN: 'run',
  OPEN_WINDOW: 'openwindow',
  COMMUNICATE: 'communicate',
  HIDE: 'hide',
  SHOW: 'show',
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
  SHOW_TOAST: 'showtoast',
  CLEAR_TOASTS: 'cleartoasts',
  REFRESH_TIMELINE: 'refreshtimeline',
  REFRESH_ENTITY: 'refreshentity',
  UPLOADFILE_REQUEST: 'uploadfile:request',
  UPDATE_SESSION_DATA: 'updatesessiondata',
  INSTALL_THIRD_PARTY_SCRIPT_REQUEST: 'installthirdpartyscript:request',
  PROMPT_REQUEST: 'prompt:request',
  RELEASE_BLOCKING_SCRIPT: 'releaseblockingscript',
};

export const RESPONSES = {
  QUERY_RESPONSE: 'query:response',
  POSTFORMDATA_RESPONSE: 'postformdata:response',
  ERROR: 'error',
  UPLOADFILE_RESPONSE: 'uploadfile:response',
  UPLOADFILE_PROGRESS: 'uploadfile:progress',
  INSTALL_THIRD_PARTY_SCRIPT_RESPONSE: 'installthirdpartyscript:response',
  PROMPT_RESPONSE: 'prompt:response',
  REFRESH_ENTITY_RESPONSE: 'refreshentity:response',
};

export const COMMUNICATIONS = {
  RUN_FRAME_SCRIPT: 'runframescript',
  SEND_MESSAGE_TO_FRAME: 'sendmessagetoframe',
  CALL_THIRD_PARTY_SCRIPT: 'callthirdpartyscript',
};
